module.exports = __webpack_public_path__ + "d39bd05d8176e630646b3398aa369733.svg";